/*
 * @Author: brucexlliu
 * @Date: 2022-05-30 15:05:10
 * @LastEditors: brucexlliu
 * @LastEditTime: 2022-06-24 15:47:10
 * @Description:
 * @FilePath: \wemeet-web-activity\src\components\ActivityInput\index.tsx
 */
import React, { useCallback, useEffect, forwardRef } from 'react';
import { Input } from '@tencent/tea-component';

type SizeType = 'full' | 'l' | 'm' | 's' | 'xs';
interface Props {
  value: string;
  setValue: Function;
  length: number;
  placeholder: string;
  size?: SizeType | undefined;
  // 错误类型：0-无错误，1-超字，2-空缺
  onError?: Function;
  disabled?: boolean;
}

// 屏蔽emoji表情
const checkValue = (val: string) =>
  val.replace(/\ud83c[\udc00-\udfff]|\ud83d[\udc00-\udfff]|[\u2000-\u2fff]/g, '');

const ActivityInput = (props: Props, ref: React.Ref<HTMLInputElement>) => {
  const { value, setValue, length, placeholder, onError, size = 'full', disabled } = props;

  const handleChange = useCallback(
    (val: string) => {
      let value = val.replace(/[<>"()]/g, '');
      value = checkValue(value);

      if (value.length > length) {
        setValue(value.substring(0, length));
        return;
      }
      setValue(value);
    },
    [length, onError],
  );

  const handleBlur = useCallback(() => {
    if (!value.trim()) {
      onError?.(2);
    }
  }, [value, onError]);

  useEffect(() => {
    if (value.length > length) {
      onError?.(1);
      return;
    }
    onError?.(0);
  }, [value]);

  return (
    <Input
      ref={ref}
      placeholder={placeholder}
      value={value}
      onChange={handleChange}
      onBlur={handleBlur}
      size={size}
      disabled={disabled}
    />
  );
};

export default forwardRef(ActivityInput);
